import React from "react";
import $ from "jquery";
import imageBgMobile from "../assets/images/alejandro-sm.jpg";
import Alejandro from "../assets/images/alejandro.jpg";
import CarrouselLogos from "../components/carrousel-logos";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mobile: window.innerWidth < 769 };
  }

  componentDidMount() {
    this.GoSectionHash();
    window.scrollTo(0, 0);
    $("body").addClass("home");

    // Detecta cambios de orientación o tamaño
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("orientationchange", this.handleResize);
  }

  componentWillUnmount() {
    // Limpia los listeners al desmontar
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("orientationchange", this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth < 769;
    if (isMobile !== this.state.mobile) {
      this.setState({ mobile: isMobile });
    }
  };

  GoSectionHash() {
    const URLhash = window.location.hash;
    const hHeader = 60;
    if (URLhash) {
      const scrollTopSection = $(URLhash).offset().top;
      $("html, body").animate({ scrollTop: scrollTopSection - hHeader }, "fast");
    }
  }

  render() {
    const { mobile } = this.state;

    return (
        <div className="slider-wrapper slide-about | m-0">
          <div className="container-fluid d-flex align-items-center">
            <div className="row">
              <div className="d-grid col-lg-6 col-xl-7 z5 mt-lg-5 pt-lg-5 mb-lg-5">
             
                {mobile && 
                  <img className="about-mobile" src={imageBgMobile} alt="Diseño 3D" />
                }
               
                <h1 className="title | scale-t1 scale-md-t4 scale-xl-t6 | mb-4 mt-3 mb-md-5 mt-lmd-5">
                  Detrás del Diseño
                </h1>

                <p className="text-secondary">
                  Soy <b className="text-branding">diseñador</b> y <b className="text-web">desarrollador digital</b>,{" "}
                  <em>
                    apasionado por crear experiencias que combinan estética,{" "}
                    <span className="text-white">funcionalidad y propósito.</span>
                  </em>{" "}
                  Me muevo entre el mundo visual y el técnico:{" "}
                  <b>
                    <em className="text-white">
                      diseño, maqueto y doy vida a interfaces que conectan con las personas
                    </em>
                  </b>.
                </p>

                <p className="text-secondary">
                  Como <b className="text-white">Design Manager</b> en Browser Travel Solutions, lidero proyectos donde el diseño se une con la tecnología para construir{" "}
                  <b>productos sólidos, escalables y con identidad.</b> A la par, dirijo{" "}
                  <b className="text-white">Sirio Studios</b>, mi estudio creativo, donde exploro nuevas formas de comunicar visualmente a través del{" "}
                  <b className="text-branding">branding</b>, el <b className="text-web">diseño web</b> y la{" "}
                  <b className="text-3d">animación 3D</b>.
                </p>

                <p className="text-secondary">
                  Mi trabajo une lo mejor de ambos mundos:{" "}
                  <b className="text-branding">diseño</b>, <b className="text-web">UX/UI</b>,{" "}
                  <b className="text-system">prototipado</b> y{" "}
                  <b className="text-branding">branding</b>, junto con HTML, CSS/SCSS, JavaScript, React.js, Next.js y{" "}
                  <b className="text-system">design systems</b>. Cada proyecto es una oportunidad para contar una historia visual con precisión técnica y un alto nivel de detalle.
                </p>

                <p className="text-secondary">
                  Creo que el buen diseño no solo se ve:{" "}
                  <b>
                    <em className="text-white">se siente, se usa y deja huella</em>
                  </b>.
                </p>

                <h2 className="title | scale-t1 scale-md-t2 | mt-3 mt-md-5 mb-4">Mis Habilidades</h2>

                <div className="carrousel">
                  <CarrouselLogos />
                  <CarrouselLogos />
                </div>

                <div className="d-flex">
                  <div className="buttom btn-quote mt-5 mb-5 d-inline">Hablemos de tu proyecto</div>
                </div>
              </div>
            </div>
          </div>

          {!mobile && (
            <div className="slide-video">
              <div className="slide enabled-slide">
                <img className="lazy slider-image" src={Alejandro} alt="Alejandro Ruiz" />
              </div>
            </div>
          )}
        </div>
      
    );
  }
}

export default Home;
